import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  神马视频
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                汇聚精彩，畅享影视。神马视频是国内领先的影视资源聚合与推荐平台，一站式发现最新电影、热播电视剧、精彩综艺和人气动漫。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                影视分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                热门推荐
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/v012" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    隐秘的角落2：暗夜追踪
                  </Link>
                </li>
                <li>
                  <Link to="/article/v006" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    鬼灭之刃：无限城篇
                  </Link>
                </li>
                <li>
                  <Link to="/article/v005" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    长安十二时辰续：盛世危局
                  </Link>
                </li>
                <li>
                  <Link to="/article/v011" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    地球脉动第四季
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    联系我们
                  </Link>
                </li>
                <li>
                  <a href="mailto:contact@shenmashipin.com" className="text-sm text-foreground-400 hover:text-background-50 transition-colors" rel="nofollow">
                    contact@shenmashipin.com
                  </a>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2024-2026 神马视频 shenmashipin.com 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-background-50 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-background-50 transition-colors" rel="nofollow">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}